<template>
  <div class="flex gap-4 items-center">
    <!-- 앞 6자리 입력 -->
    <div class="relative">
      <input v-if="!isPrint" ref="frontInput" type="text" :readonly="readonly" maxlength="6" :style="{ width: '8rem' }" v-model="frontDigits" @input="onFrontInput" />
      <!-- 프린트 모드: 각 자릿수별 네모칸 -->
      <div v-else class="print-digits">
        <span v-for="(digit, index) in frontDigitsArray" :key="`front-${index}`" class="digit-box">
          {{ digit }}
        </span>
      </div>
    </div>

    <!-- 하이픈 -->
    <span class="hyphen">-</span>

    <!-- 뒷자리: 첫 번째 1자리 + 6자리 마스킹 -->
    <div class="flex">
      <input v-if="!isPrint" ref="backInput" type="text" :readonly="readonly" maxlength="1" :style="{ width: '2rem' }" v-model="backFirstDigit" @input="onBackInput" />
      <!-- 프린트 모드: 첫 번째 자릿수 네모칸 -->
      <div v-else class="print-digits">
        <span class="digit-box">{{ backFirstDigit }}</span>
      </div>
      <span class="masked-digits">******</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "ResidentNumberInput",
  props: {
    value: String,
    readonly: Boolean,
    isPrint: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      frontDigits: "",
      backFirstDigit: "",
    };
  },
  computed: {
    frontDigitsArray() {
      // 6자리로 패딩하여 배열로 변환
      const padded = this.frontDigits.padEnd(6, " ");
      return padded.split("");
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        if (value && value.length >= 1) {
          this.frontDigits = value.substring(0, 6);
          this.backFirstDigit = value.substring(6, 7);
        } else if (!value) {
          this.frontDigits = "";
          this.backFirstDigit = "";
        }
      },
    },
  },
  methods: {
    onFrontInput() {
      // 숫자만 입력 허용
      this.frontDigits = this.frontDigits.replace(/[^0-9]/g, "");

      // 월 검증 (3,4번째 자리)
      if (this.frontDigits.length >= 4) {
        const month = this.frontDigits.substring(2, 4);
        if (month > 12 || (month.length === 2 && month < 1)) {
          this.frontDigits = this.frontDigits.substring(0, 2);
          return;
        }
      }

      // 일 검증 (5,6번째 자리)
      if (this.frontDigits.length >= 6) {
        const month = this.frontDigits.substring(2, 4);
        const day = this.frontDigits.substring(4, 6);

        // 월별 최대 일수 검증
        const daysInMonth = this.getDaysInMonth(parseInt(month));
        if (day > daysInMonth || (day.length === 2 && day < 1)) {
          this.frontDigits = this.frontDigits.substring(0, 4);
          return;
        }
      }

      // 6자리가 되면 다음 입력으로 자동 이동
      if (this.frontDigits.length === 6 && this.$refs.backInput) {
        this.$refs.backInput.focus();
      }

      this.emitValue();
    },
    onBackInput() {
      // 숫자만 입력 허용
      this.backFirstDigit = this.backFirstDigit.replace(/[^0-9]/g, "");

      // 성별/국적 코드 검증 (1-8 허용)
      if (this.backFirstDigit && ![1, 2, 3, 4, 5, 6, 7, 8].includes(parseInt(this.backFirstDigit))) {
        this.backFirstDigit = "";
        return;
      }

      this.emitValue();
    },
    getDaysInMonth(month) {
      // 각 월별 최대 일수 (윤년 고려하지 않고 2월은 29일로 설정)
      const daysInMonths = {
        1: 31,
        2: 29,
        3: 31,
        4: 30,
        5: 31,
        6: 30,
        7: 31,
        8: 31,
        9: 30,
        10: 31,
        11: 30,
        12: 31,
      };
      return daysInMonths[month] || 31;
    },
    emitValue() {
      const fullValue = this.frontDigits + this.backFirstDigit;
      this.$emit("input", fullValue);
    },
  },
};
</script>

<style lang="scss" scoped>
input {
  position: relative;
  font-size: 1rem !important;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  box-sizing: border-box;
  box-shadow: 0 0 0 0 rgb(0 0 0 / 15%);
  outline: none;
  text-transform: none;
  text-decoration: none;
  padding: 0.7rem !important;
  transition: all 0.3s ease;
  text-align: center;

  &:focus {
    border: 1px solid rgba(var(--vs-primary), 1) !important;
    box-shadow: 0 3px 10px 0 rgb(0 0 0 / 15%);
  }
}

.hyphen {
  font-size: 1rem;
  font-weight: bold;
  color: #666;
}

.masked-digits {
  display: flex;
  align-items: center;
  font-size: 1rem;
  color: #666;
  letter-spacing: 0.1em;
  margin-left: 0.2rem;
}

// 프린트 모드 스타일
.print-digits {
  display: flex;
  //gap: 2px;
}

.digit-box {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.2rem;
  height: 2.2rem;
  border: 1px solid #cdcdcd;
  border-right: none;
  background-color: #fff;
  font-size: 1rem;
  font-weight: normal;
  text-align: center;

  // 마지막 요소는 오른쪽 테두리 유지
  &:last-child {
    border-right: 1px solid #cdcdcd;
  }
}
</style>